import type { IsExact, IsNever } from 'conditional-type-checks';

import { typetest } from './typetest';

type TypeExpectations<T> = {
  toBeExactly: <U extends T>(y: IsExact<T, U>) => void;
  toBeNever: (y: IsNever<T>) => void;
  returnType: T extends (...args: never) => infer R
    ? TypeExpectations<R>
    : never;
};

export const expectType: <T>(x: T) => TypeExpectations<T> = typetest;
